import React, { useState, useEffect } from "react";
import {
  Grid,
  Paper,
  Box,
  Button,
  useMediaQuery,
  useTheme,
  Typography,
} from "@mui/material";
import { DataGridPro, GridNoRowsOverlay } from "@mui/x-data-grid-pro";
import LoadingButton from "@mui/lab/LoadingButton";
import { Storage } from "aws-amplify";
import { cleanupRowCount, createHeaders, createRows } from "../../../methods";
import { handleBlobDownload } from "../../../methods";
import Loading from "../../Loading";
import { GenerateAndDownloadFile } from "../../../services";
import DataAIModal from "../../DataAIModal";

const S3_WRITER = "SnowflakeS3Writer";


const QueryResults = ({ resultData, fetchFunctions, initialQuery, isLoading, fileName, db, sql, entities, isSqlDisabled, setSnackbarInfo }) => {
  const [loading, setLoading] = useState(false);
  const [fileSize, setFileSize] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const data = resultData || {};
  const rowCount = data?.rowCount || 0;
  const response = data?.response ? JSON.parse(data.response) : [];

  const headers = createHeaders(response);
  const rows = createRows(response);
  const count = cleanupRowCount(rowCount);

  useEffect(() => {
    if (resultData?.success) {
      setLoading(true);
      getStorageFile()
        .then((res) => {
          if (fileSize === res[0]?.size) {
            setLoading(false);
          } else {
            setFileSize(res[0]?.size);
          }
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    }
  }, [data, fileSize]);

  const getStorageFile = async () => {
    const results = await Storage.list(fileName, { level: "private" });
    return results;
  };

  const downloadStorageFile = async () => {
    setLoading(true);

    try {
      // Use the signed URL instead of rebuilding the key - let the server
      // decide which zip belongs to this run
      const generateResult = await GenerateAndDownloadFile({
        body: { dbType: S3_WRITER, fileName, writerSQL: sql, db, entities },
      });

      if (!generateResult?.success) {
        throw new Error("Download generation did not complete successfully.");
      }

      const archiveResponse = await fetch(generateResult.data.signedUrl);

      if (!archiveResponse.ok) {
        throw new Error(
          `Could not retrieve the generated file (${archiveResponse.status}).`
        );
      }

      await handleBlobDownload(await archiveResponse.blob(), fileName);
    } catch (error) {
      console.error(error);
      setSnackbarInfo?.({
        open: true,
        message: error?.message
          ? `Error downloading file: ${error.message}`
          : "Error downloading file. Please try again.",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const showDataTable = () => {
    if (isLoading) return <Loading />
    if (resultData?.response == "Retry") return <Button color="error" onClick={() => fetchFunctions.fetchTopTenDiagnosisData(initialQuery)}>Retry</Button>;

    return (
      <DataGridPro
        sx={{
          height: "500px",
        }}
        loading={isLoading}
        rows={rows}
        columns={headers}
        rowCount={count}
        disableRowSelectionOnClick
        slots={{
          noRowsOverlay: () => (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
              Please run query to see results
            </div>
          )
        }}
      />
    );
  }
  return (
    <>
      <Grid container>
        <Grid size={12}>
          <Box
            sx={{
              padding: 2,
              display: 'flex',
              justifyContent: 'space-between',
              backgroundColor: "#626c91",
              color: "white",
              fontSize: "1rem",
            }}
          >
            <Typography variant="h6" sx={{ color: "white" }}>
              Query Results
            </Typography>
            <Box
              sx={{ display: 'flex' }}
            >
              {/* <Button
                sx={{
                  color: "white",
                  border: '1px solid white'
                }}
                variant="outlined"
                onClick={() => setOpenModal(true)}
                disabled={isSqlDisabled}
              >
                RWE AI
              </Button> */}
            </Box>
          </Box>
          <Box>
            {showDataTable()}
          </Box>
        </Grid>
      </Grid>
      <DataAIModal openModal={openModal} handleCloseModal={setOpenModal} sql={sql} db={db} />
    </>
  );
};

export default QueryResults;
